import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Navbar from './Navbar';
import axios from '../../axios/axios';
import Snackbar, { openSnackbar } from '../utils/Snackbar';
import { connect } from "react-redux";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import CircularProgress from '@material-ui/core/CircularProgress';


function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '10px auto',
        textAlign: 'center'
    },
    line1: {
        margin: '10px 0',
        fontSize: '60px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '35px'
        }
    },
    button: {
        margin: '10px 0',
        color: '#FFFFFF',
        backgroundColor: '#ff9933',
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#e67300'
        }
    },
    header: {
        backgroundColor: '#e67300',
        borderRadius: '5px',
        color: '#FFFFFF'
    },
    subHeader: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
        cursor: 'pointer'
    },
    heading: {
        margin: '10px 0',
        fontSize: '25px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px'
        }
    },
    subHeading: {
        margin: '10px 0',
        fontSize: '22px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px'
        }
    },
    dialogContent: {
        margin: '5px',
    },
    details: {
        margin: '5px 0',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '17px'
        }
    },
    deleteBT: {
        margin: '10px 0',
        color: '#FFFFFF',
        backgroundColor: 'red'
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

class ManageContact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            contactList: [],
            hasMore: true,
            limit: 25,
            contact: null,
            loading: true
        }
    }

    componentDidMount() {
        if (this.props.token === "") {
            this.props.history.push("/admin");
            return;
        }
        this.fetchContacts();
    }

    fetchContacts = () => {
        axios.get(`contact/fetchContacts?offset=${this.state.contactList.length}&limit=${this.state.limit}`, {
            headers: {
                authorization: `Bearer ${this.props.token}`
            }
        }).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    this.setState(prevState => ({
                        contactList: [...prevState.contactList, ...result.data.contacts]
                    }), () => {
                        this.setState({
                            loading: false
                        });
                        if (result.data.contacts.length === 0 || this.state.contactList.length < this.state.limit) {
                            this.setState({
                                hasMore: false
                            });
                        }
                    });
                } else {
                    openSnackbar({ message: result.data.msg, variant: "error" });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    deleteContact = (id) => {
        axios.delete(`contact/?id=${id}`, {
            headers: {
                authorization: `Bearer ${this.props.token}`
            }
        }).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    openSnackbar({ message: result.data.msg, variant: "success" });
                    const newList = this.state.contactList.filter(contact => {
                        return contact.id !== id;
                    });

                    this.setState({
                        contactList: newList,
                        open: false
                    });
                } else {
                    openSnackbar({ message: result.data.msg, variant: "error" });
                    this.setState({ open: false });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    handleClickOpen = (contact) => {
        this.setState({
            open: true,
            contact: contact
        });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <Navbar />
                <Snackbar />
                <div className={classes.container}>
                    <Typography variant="h1" className={classes.line1}>Manage Contact</Typography>
                    <br />
                    <div className={classes.header}>
                        <Grid container>
                            <Grid item xs={4} className={classes.heading}>Name</Grid>
                            <Grid item xs={4} className={classes.heading}>Mobile</Grid>
                            <Grid item xs={4} className={classes.heading}>Action</Grid>
                        </Grid>
                    </div>
                    {this.state.contactList.map(contact => {
                        return (
                            <div className={classes.subHeader} key={contact.id} onClick={() => this.handleClickOpen(contact)}>
                                <Grid container>
                                    <Grid item xs={4} className={classes.subHeading}>{contact.name}</Grid>
                                    <Grid item xs={4} className={classes.subHeading}>{contact.mobile}</Grid>
                                    <Grid item xs={4} className={classes.subHeading}>
                                        <Typography variant="inherit">
                                            <span style={{ color: 'red', fontWeight: '400', cursor: 'pointer' }} onClick={() => this.handleClickOpen(contact)}>Delete</span>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        );
                    })}
                    {this.state.loading ? (<CircularProgress className={classes.progress} color="secondary" />) : null}
                    <br />
                    {this.state.hasMore ? (<Button variant="outlined" color="secondary" className={classes.loadMore}
                        onClick={() => {
                            this.fetchContacts();
                        }}>Load More</Button>) : null}

                    {this.state.contact !== null ?
                        <Dialog
                            open={this.state.open}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle id="scroll-dialog-title">Contact Info</DialogTitle>
                            <DialogContent className={classes.dialogContent}>

                                <Typography variant="inherit" className={classes.details}><b>Name : </b>{`${this.state.contact.name}`}</Typography>
                                <Typography variant="inherit" className={classes.details}><b>Mobile : </b>{`${this.state.contact.mobile}`}</Typography>
                                <Typography variant="inherit" className={classes.details}><b>Email : </b>{`${this.state.contact.email}`}</Typography>
                                <Typography variant="inherit" className={classes.details}><b>Message : </b>{`${this.state.contact.message}`}</Typography>

                                <Button variant="outlined" color="secondary" className={classes.deleteBT}
                                    onClick={() => {
                                        this.deleteContact(this.state.contact.id);
                                    }}>Delete</Button>

                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="primary">
                                    Cancel</Button>
                            </DialogActions>
                        </Dialog>
                        : null}
                </div>
            </Fragment>
        );
    }
}

ManageContact.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => {
    return {
        token: state.login.token
    }
}

export default connect(mapStateToProps)(withStyles(styles)(ManageContact));